import React, { useState, useEffect } from "react";
import AddMaterials from "../Materials/AddMaterials";
import AddServices from "../Services/AddServices";
import AddOrdenes from "./AddOrdenes";
import { database } from "../../firebase";
import { ref, onValue, query, orderByChild, limitToLast, equalTo, set } from "firebase/database";
import { getFirestore, collection, query as queryFirestore, getDocs, orderBy, limit, setDoc, doc, where, addDoc, runTransaction, getDoc } from "firebase/firestore";
import ProductosDataService from "../../services/ordenes.service";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { updateCuadrillaFirestore } from '../../services/cuadrillasService';
import { releasePreQuantityForOrden } from '../../services/preStockService';
import { Autocomplete, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, OutlinedInput, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import Paper from '@mui/material/Paper';
import moment from "moment";
const firestore = getFirestore();

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function OTWrapper() {
    const [actualStep, setActualStep] = useState('order');
    let [dataToSave, setDataToSave] = useState([])
    const [snackbarInfo, setSnackbarInfo] = useState({ text: '', type: '', open: false });
    const [openGarantiaModal, setOpenGarantiaModal] = useState(false)
    const [otGarantiaData, setOtGarantiaData] = useState([])
    const [checkRow, setCheckRow] = useState([])
    const [garantias, setGarantias] = useState([])
    const [services, setServices] = useState([]);
    // const [materialsData, setMaterialsData] = useState([])
    const ordenesCollection = collection(firestore, 'ordenes');

    const getServicesOnce = async () => {
        try {
            const servicesCollection = collection(firestore, 'servicios');
            const queryServices = queryFirestore(servicesCollection, orderBy('id', 'asc'));
            const snapshot = await getDocs(queryServices);
            const data = snapshot.docs.map(doc => doc.data());
            setServices(data);
        } catch (error) {
            console.error("Error al obtener los datos de servicios:", error);
        }
    }

    useEffect(() => {
        getServicesOnce()
    }, []);

    const goToService = (data) => {
        setDataToSave(prevState => ({ ...prevState, ...data }));
        setActualStep('service')
    }

    const goToMaterials = (services) => {
        setDataToSave(prevState => ({ ...prevState, ...services }));
        // setDataToSave(services);
        setActualStep('material')
    }

    const goToOrder = () => {
        setActualStep('order')
    }

    const validateFormulario = async (newData) => {
        console.log('🔍 === INICIO validateFormulario ===');
        console.log('🔍 Validando garantías para contrato:', newData?.contrato);
        
        try {
            const dateOt = moment(newData?.date);
            const dateFrom = moment(dateOt).subtract(30, 'days').format("YYYYMMDD");
            const dateTo = moment(dateOt).add(30, 'days').format("YYYYMMDD");
            
            console.log('🔍 Rango de fechas para búsqueda:', { dateFrom, dateTo });
            
            const searchQuery = queryFirestore(ordenesCollection, orderBy('contrato', 'asc'), where('contrato', '==', newData?.contrato));
            const querySnapshot = await getDocs(searchQuery);

            if (!querySnapshot.empty) {
                const data = querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
                console.log(`🔍 Encontradas ${data.length} órdenes con el mismo contrato`);
                
                const registrosFiltrados = data.filter(registro => {
                    const date = registro.date;
                    return date >= dateFrom && date <= dateTo;
                });
                
                console.log(`🔍 ${registrosFiltrados.length} órdenes en el rango de fechas (posibles garantías)`);
                
                if (registrosFiltrados.length > 0) {
                    const arrayRegistros = registrosFiltrados;
                    console.log('🔍 Garantías detectadas, mostrando modal');
                    setActualStep('finish')
                    setOtGarantiaData(arrayRegistros)
                    setOpenGarantiaModal(true)
                } else {
                    console.log('🔍 No se encontraron garantías, finalizando proceso');
                    setOpenGarantiaModal(false)
                    setActualStep('finish')
                }
            } else {
                console.log('🔍 No se encontraron órdenes previas con este contrato');
                setOpenGarantiaModal(false)
                setActualStep('finish')
            }
            
            console.log('✅ validateFormulario completado exitosamente');
            
        } catch (error) {
            console.error('❌ Error en validateFormulario:', error);
            
            // En caso de error, asumir que no hay garantías y continuar
            console.log('🔄 Error en validación de garantías, continuando sin modal');
            setOpenGarantiaModal(false)
            setActualStep('finish')
            
            setSnackbarInfo({ 
                text: 'Advertencia: No se pudo validar garantías, pero la orden se guardó correctamente', 
                type: 'warning', 
                open: true 
            });
        }
        
        console.log('🔍 === FIN validateFormulario ===');
    };

    // Normaliza un valor para comparación robusta (string trimmeado)
    const normalizeForCompare = (value) => {
        if (value === null || value === undefined) return '';
        return String(value).trim();
    };

    // Función para eliminar una orden específica del array de órdenes de una cuadrilla
    const removeOrderFromCuadrilla = async (cuadrillaId, orderToRemove) => {
        try {
            console.log('🔄 Eliminando orden de cuadrilla:', { cuadrillaId, orderToRemove });

            // Obtener cuadrillas actualizadas desde la base de datos
            const cuadrillasCollection = collection(firestore, 'cuadrillas');

            // Buscar con tipo original; si no aparece, reintentar con tipo coercionado (string/number)
            let cuadrillaQuery = queryFirestore(cuadrillasCollection, where('id', '==', cuadrillaId));
            let querySnapshot = await getDocs(cuadrillaQuery);

            if (querySnapshot.empty) {
                const altId = typeof cuadrillaId === 'number' ? String(cuadrillaId) : Number(cuadrillaId);
                if (!Number.isNaN(altId) && altId !== '' && altId !== cuadrillaId) {
                    console.warn(`⚠️ Cuadrilla no encontrada con id=${cuadrillaId} (${typeof cuadrillaId}), reintentando con ${altId} (${typeof altId})`);
                    cuadrillaQuery = queryFirestore(cuadrillasCollection, where('id', '==', altId));
                    querySnapshot = await getDocs(cuadrillaQuery);
                }
            }

            if (querySnapshot.empty) {
                throw new Error(`Cuadrilla con ID ${cuadrillaId} no encontrada`);
            }

            const cuadrillaDoc = querySnapshot.docs[0];
            const cuadrillaData = cuadrillaDoc.data();
            const currentOrders = cuadrillaData.ordenes || [];

            console.log('📊 Órdenes actuales en cuadrilla:', currentOrders.length);

            const targetNroOt = normalizeForCompare(orderToRemove?.nroOt);
            const targetNroFormulario = normalizeForCompare(orderToRemove?.nroFormulario);
            const targetContrato = normalizeForCompare(orderToRemove?.contrato);

            // Filtrar la orden específica con comparación robusta:
            // - Coincidencia por nroOt (string trimmeado) — campo principal
            // - Si no, fallback combinado por nroFormulario + contrato
            const updatedOrders = currentOrders.filter(order => {
                const orderNroOt = normalizeForCompare(order?.nroOt);
                if (targetNroOt && orderNroOt && orderNroOt === targetNroOt) {
                    return false;
                }
                if (!targetNroOt && targetNroFormulario && targetContrato) {
                    const orderNroFormulario = normalizeForCompare(order?.nroFormulario);
                    const orderContrato = normalizeForCompare(order?.contrato);
                    if (orderNroFormulario === targetNroFormulario && orderContrato === targetContrato) {
                        return false;
                    }
                }
                return true;
            });

            console.log('📊 Órdenes después del filtrado:', updatedOrders.length);

            if (updatedOrders.length === currentOrders.length) {
                console.error('⚠️ La orden no se encontró en la cuadrilla para eliminar', {
                    targetNroOt,
                    currentOrdersNroOts: currentOrders.map(o => normalizeForCompare(o?.nroOt))
                });
                throw new Error(`No se pudo eliminar la orden ${targetNroOt} de la cuadrilla (no se encontró coincidencia)`);
            }

            // Actualizar SOLO el campo ordenes para evitar pisar otros cambios concurrentes
            await updateCuadrillaFirestore(cuadrillaId, {
                ordenes: updatedOrders
            });

            console.log('✅ Orden eliminada exitosamente de la cuadrilla');

        } catch (error) {
            console.error('❌ Error eliminando orden de cuadrilla:', error);
            throw error;
        }
    };

    const saveOnlyOrder = async (materialsData, retryCount = 0) => {
        console.log('💾 === INICIO saveOnlyOrder ===');
        if (retryCount > 0) {
            console.log(`🔄 Reintento #${retryCount} debido a conflicto de concurrencia`);
        }
        console.log('💾 Datos a guardar:', { dataToSave, materialsData });
        
        let ordenId = null;
        let ordenGuardada = false;
        let newDataOrderToSave = null;

        try {
            // ✅ PASO 1: Validar datos críticos antes de proceder
            const newArray = { ...dataToSave };
            const now = moment(new Date().getTime());
            const dateHour = now.format("DD/MM/YYYY HH:mm");
            const dateForQuery = now.format("YYYYMMDD"); // Formato para consultas eficientes
            
            newArray.confectionData = dateHour; // Formato legible para mostrar
            newArray.confectionDate = dateForQuery; // Formato para consultas (igual que 'date')
            
            // ✅ Los seriales vienen como arrays de strings desde AddMaterials.js, no necesitan fechaUltimaModificacion aquí
            console.log('🔍 VERIFICANDO ESTRUCTURA DE SERIALES:');
            console.log('📄 serialOnt tipo:', typeof materialsData.serialOnt?.[0], 'valor:', materialsData.serialOnt?.[0]);
            console.log('📄 serialesFlow tipo:', typeof materialsData.serialesFlow?.[0], 'valor:', materialsData.serialesFlow?.[0]);
            console.log('📄 serialesExt tipo:', typeof materialsData.serialesExt?.[0], 'valor:', materialsData.serialesExt?.[0]);
            
            newDataOrderToSave = { ...newArray, ...materialsData };
            // Quitar undefined del objeto para que Firestore no falle al guardar
            Object.keys(newDataOrderToSave).forEach(key => {
                if (newDataOrderToSave[key] === undefined) {
                    delete newDataOrderToSave[key];
                }
            });

            const camposRequeridos = ['nroOt', 'nroFormulario', 'contrato', 'cliente', 'cuadrilla'];
            const camposFaltantes = camposRequeridos.filter(campo => 
                !newDataOrderToSave[campo] || newDataOrderToSave[campo] === ''
            );
            
            if (camposFaltantes.length > 0) {
                throw new Error(`Campos requeridos faltantes: ${camposFaltantes.join(', ')}`);
            }

            console.log('✅ Validación de datos completada');

            // ✅ PASO 1.5: Verificar que no exista una orden con el mismo nroOt (ANTES de la transacción)
            console.log('🔄 PASO 1.5: Verificando duplicados de nroOt...');
            const firestore = getFirestore();
            const ordenesCollection = collection(firestore, "ordenes");
            
            // Verificar si ya existe una orden con el mismo nroOt
            const duplicateQuery = queryFirestore(
                ordenesCollection, 
                where("nroOt", "==", newDataOrderToSave.nroOt)
            );
            const duplicateSnapshot = await getDocs(duplicateQuery);
            
            if (!duplicateSnapshot.empty) {
                const existingOrder = duplicateSnapshot.docs[0].data();
                throw new Error(`Ya existe una orden con el número OT ${newDataOrderToSave.nroOt} (ID: ${existingOrder.id}). No se puede duplicar.`);
            }
            
            console.log('✅ Verificación de duplicados completada');

            // ✅ PASO 2: Guardar la orden usando transacción mejorada
            console.log('🔄 PASO 2: Guardando orden en base de datos con transacción...');
            
            ordenId = await runTransaction(firestore, async (transaction) => {
                // ✅ Verificar duplicidad de nroOt de forma atómica dentro de la transacción
                const nroOtLimpio = newDataOrderToSave.nroOt.toString().trim();
                const uniqueOtRef = doc(firestore, "unique_nroOts", nroOtLimpio);
                const uniqueOtDoc = await transaction.get(uniqueOtRef);
                
                if (uniqueOtDoc.exists()) {
                    throw new Error(`Ya existe una orden con el número OT ${nroOtLimpio}. No se puede duplicar.`);
                }

                // ✅ Dentro de la transacción, consultar el último ID de forma atómica
                const q = queryFirestore(ordenesCollection, orderBy("id", "desc"), limit(1));
                const querySnapshot = await getDocs(q);

                let lastId = 0;
                if (!querySnapshot.empty) {
                    querySnapshot.forEach((doc) => {
                        lastId = doc.data().id;
                    });
                }

                // Generar el nuevo ID
                const newId = lastId + 1;
                newDataOrderToSave.id = newId;
                
                // ✅ Verificación adicional dentro de la transacción
                const duplicateCheckRef = doc(firestore, "ordenes", newId.toString());
                const duplicateCheckDoc = await transaction.get(duplicateCheckRef);
                
                if (duplicateCheckDoc.exists()) {
                    throw new Error(`Conflicto de ID detectado: El ID ${newId} ya existe. Intente nuevamente.`);
                }
                
                console.log(`💾 ID generado para la orden: ${newId}`);
                console.log('💾 Datos finales a guardar:', {
                    id: newId,
                    nroOt: newDataOrderToSave.nroOt,
                    contrato: newDataOrderToSave.contrato,
                    cliente: newDataOrderToSave.cliente,
                    materialesCount: newDataOrderToSave.materials?.length || 0,
                    serialesOnt: newDataOrderToSave.serialOnt?.length || 0,
                    serialesFlow: newDataOrderToSave.serialesFlow?.length || 0
                });

                // Registrar el nroOt en la colección de únicos
                transaction.set(uniqueOtRef, { id: newId, timestamp: Date.now() });

                // Guardar el nuevo documento
                transaction.set(duplicateCheckRef, newDataOrderToSave);
                
                return newId;
            });

            ordenGuardada = true;
            console.log(`✅ PASO 2 COMPLETADO: Orden guardada exitosamente con ID: ${ordenId}`);

            // ✅ PASO 3: Verificar que la orden se guardó (sanity check, NO crítico)
            // La transacción ya garantiza atomicidad: si llegamos acá, el write fue commiteado.
            // Este getDoc puede leer stale por consistencia eventual; nunca debe abortar el flujo.
            try {
                console.log('🔄 PASO 3: Verificando que la orden se guardó correctamente...');
                const verificacionRef = doc(firestore, "ordenes", ordenId.toString());
                const verificacionDoc = await getDoc(verificacionRef);

                if (!verificacionDoc.exists()) {
                    console.warn(`⚠️ PASO 3: read-back no encontró la orden ID ${ordenId} (probable consistencia eventual). La transacción ya fue commiteada, se asume guardada.`);
                } else {
                    const datosVerificados = verificacionDoc.data();
                    if (datosVerificados.nroOt !== newDataOrderToSave.nroOt) {
                        console.warn(`⚠️ PASO 3: nroOt leído (${datosVerificados.nroOt}) difiere del esperado (${newDataOrderToSave.nroOt}). Se confía en la transacción.`);
                    } else {
                        console.log('✅ PASO 3 COMPLETADO: Orden verificada en base de datos');
                    }
                }
            } catch (verifyError) {
                console.warn('⚠️ PASO 3: Error en verificación post-guardado (no crítico):', verifyError);
            }

            // ✅ PASO 4: Eliminar la orden de la cuadrilla si fue seleccionada del autocomplete
            if (newDataOrderToSave.selectedOrderInfo && !newDataOrderToSave.isManualOrder) {
                console.log('🔄 PASO 4: Eliminando orden usada de la cuadrilla...');

                // Validar que tenemos el ID de cuadrilla (idCuadrilla puede ser 0)
                if (newDataOrderToSave.idCuadrilla === undefined || newDataOrderToSave.idCuadrilla === null || newDataOrderToSave.idCuadrilla === -1) {
                    console.warn('⚠️ No se puede eliminar orden de cuadrilla: idCuadrilla inválido', {
                        selectedOrderInfo: newDataOrderToSave.selectedOrderInfo,
                        isManualOrder: newDataOrderToSave.isManualOrder,
                        idCuadrilla: newDataOrderToSave.idCuadrilla,
                        todasLasClaves: Object.keys(newDataOrderToSave)
                    });
                    setSnackbarInfo({
                        text: `⚠️ Orden guardada, pero no se pudo eliminar de la cuadrilla (idCuadrilla inválido). Revisá el listado de órdenes de la cuadrilla.`,
                        type: 'warning',
                        open: true
                    });
                } else {
                    try {
                        if (newDataOrderToSave.selectedOrderInfo?.materiales?.length) {
                            await releasePreQuantityForOrden(
                                newDataOrderToSave.idCuadrilla,
                                newDataOrderToSave.selectedOrderInfo.materiales
                            );
                        }

                        await removeOrderFromCuadrilla(
                            newDataOrderToSave.idCuadrilla,
                            newDataOrderToSave.selectedOrderInfo
                        );
                        console.log('✅ PASO 4 COMPLETADO: Orden eliminada de la cuadrilla exitosamente');
                    } catch (removeError) {
                        console.error('❌ Error eliminando orden de cuadrilla:', removeError);
                        // Avisar al usuario para que pueda eliminarla manualmente si quedó duplicada
                        setSnackbarInfo({
                            text: `⚠️ Orden guardada, pero no se pudo eliminar de la cuadrilla: ${removeError.message}`,
                            type: 'warning',
                            open: true
                        });
                    }
                }
            } else {
                console.log('ℹ️ PASO 4: Orden manual o sin selección de autocomplete, no se elimina de cuadrilla');
            }

            // ✅ ÉXITO DE GUARDADO DE ORDEN (la validación de garantías y transición a 'finish' se ejecutan en onSave LUEGO de descontar materiales y seriales)
            setSnackbarInfo({ 
                text: `✅ Orden ${newDataOrderToSave.nroOt} guardada exitosamente (ID: ${ordenId})`, 
                type: 'success', 
                open: true 
            });
            
            console.log('💾 === FIN saveOnlyOrder EXITOSO ===');
            return newDataOrderToSave;

        } catch (error) {
            console.error("❌ Error crítico al guardar la orden:", error);

            // ✅ SI LA ORDEN YA FUE GUARDADA, no abortamos ni reintentamos:
            // un retry crearía una orden duplicada o (más común) lanzaría
            // "Ya existe una orden con el número OT XYZ" confundiendo al usuario.
            if (ordenGuardada) {
                console.warn('⚠️ Error en pasos post-guardado, pero la orden YA fue persistida. No se reintenta.');
                setSnackbarInfo({
                    text: `✅ Orden ${newDataOrderToSave?.nroOt} guardada (ID: ${ordenId}). ⚠️ Advertencia post-guardado: ${error.message}`,
                    type: 'warning',
                    open: true
                });
                console.log('💾 === FIN saveOnlyOrder (guardado OK, warning post-guardado) ===');
                return newDataOrderToSave;
            }

            // ✅ MANEJO DE REINTENTOS PARA CONFLICTOS DE CONCURRENCIA (solo si NO se guardó)
            const maxRetries = 3;
            const isConcurrencyError = error.message?.includes('Conflicto de ID detectado') ||
                                     error.message?.includes('already exists') ||
                                     error.message?.includes('concurrent modification');

            if (isConcurrencyError && retryCount < maxRetries) {
                console.log(`🔄 Detectado conflicto de concurrencia. Reintentando... (${retryCount + 1}/${maxRetries})`);

                // Esperar un tiempo aleatorio antes del reintento para evitar conflictos
                const delay = Math.random() * 1000 + 500; // 500-1500ms
                await new Promise(resolve => setTimeout(resolve, delay));

                // Reintentar la operación
                return saveOnlyOrder(materialsData, retryCount + 1);
            }
            
            // ✅ MANEJO DETALLADO DE ERRORES
            let mensajeError = 'Error desconocido al guardar la orden';
            
            if (error.message?.includes('Campos requeridos faltantes')) {
                mensajeError = `Datos incompletos: ${error.message}`;
            } else if (error.message?.includes('permission-denied')) {
                mensajeError = 'Sin permisos para guardar. Contacte al administrador.';
            } else if (error.message?.includes('network') || error.message?.includes('fetch')) {
                mensajeError = 'Error de conexión. Verifique su internet e intente nuevamente.';
            } else if (error.message?.includes('timeout')) {
                mensajeError = 'La operación tardó demasiado. Intente nuevamente.';
            } else if (error.message?.includes('quota-exceeded')) {
                mensajeError = 'Base de datos llena. Contacte al administrador.';
            } else if (isConcurrencyError && retryCount >= maxRetries) {
                mensajeError = 'Error de concurrencia después de múltiples intentos. Intente nuevamente en unos segundos.';
            } else {
                mensajeError = `Error al guardar: ${error.message}`;
            }
            
            // ✅ NOTIFICAR ERROR AL USUARIO (la orden NO se guardó en este branch)
            setSnackbarInfo({
                text: `❌ ${mensajeError}`,
                type: 'error',
                open: true
            });

            // ✅ LOGGING DETALLADO PARA DEBUGGING
            console.log('📊 Estado del error:', {
                ordenGuardada,
                ordenId,
                tipoError: error.constructor.name,
                codigoError: error.code,
                mensajeOriginal: error.message,
                esErrorConcurrencia: isConcurrencyError,
                reintentosRealizados: retryCount,
                timestamp: new Date().toISOString()
            });

            // La orden NO fue guardada: volver al paso anterior para reintento manual
            console.log('🔄 Revirtiendo al paso de materiales debido al error...');
            setActualStep('material');

            // ✅ RE-LANZAR ERROR PARA MANEJO UPSTREAM
            throw new Error(`${mensajeError} (Detalles: ${error.message})`);
        }
    };

    const onSave = async (materialsDate, onSuccessCallback) => {
        console.log('🔄 === INICIO onSave ===');
        console.log('🔄 Datos de materiales recibidos:', materialsDate);
        
        try {
            // ✅ PASO 1: Guardar la orden primero
            const savedOrderData = await saveOnlyOrder(materialsDate);
            console.log('✅ Orden guardada exitosamente');
            
            // ✅ PASO 2: Solo si la orden se guardó exitosamente, ejecutar callback (descontar materiales y seriales ANTES de cambiar a 'finish')
            if (onSuccessCallback && typeof onSuccessCallback === 'function') {
                console.log('🔄 Ejecutando actualizaciones de materiales y seriales...');
                try {
                    await onSuccessCallback();
                    console.log('✅ Actualizaciones de materiales y seriales completadas');
                } catch (callbackError) {
                    console.error('❌ Error en actualizaciones post-guardado:', callbackError);
                    setSnackbarInfo({ 
                        text: `⚠️ Orden guardada pero error en actualizaciones: ${callbackError.message}`, 
                        type: 'warning', 
                        open: true 
                    });
                }
            }

            // ✅ PASO 3: Ahora que los materiales y seriales ya se descontaron de la cuadrilla, validar garantías y pasar a 'finish'
            console.log('🔄 PASO 3: Ejecutando validación de garantías y finalizando...');
            try {
                await validateFormulario(savedOrderData || { ...dataToSave, ...materialsDate });
                console.log('✅ Validación de garantías exitosa');
            } catch (garantiaError) {
                console.warn('⚠️ Error en validación de garantías (no crítico):', garantiaError);
                setActualStep('finish');
            }
            
            console.log('✅ onSave completado exitosamente');
        } catch (error) {
            console.error('❌ Error en onSave:', error);
            
            // El error ya fue manejado en saveOnlyOrder
            console.log('🔄 onSave falló, no se ejecutarán actualizaciones de materiales');
            
            // Re-lanzar para que AddMaterials pueda manejar el estado
            throw error;
        }
        
        console.log('🔄 === FIN onSave ===');
    }

    const saveOt = (lastId, materialsData) => {
        const newArray = dataToSave
        const dateHour = moment(new Date().getTime()).format("DD/MM/YYYY HH:mm")
        const newId = lastId + 1;
        newArray.id = newId;
        newArray.confectionData = dateHour;
        const newData = { ...newArray, ...materialsData }
        ProductosDataService.create(newData, newId)
            .then(() => {
                validateFormulario(newData);
                // setTimeout(() => {
                //         setActualStep('finish')
                //     }, 1000);
            })
            .catch((e) => {
                setSnackbarInfo({ text: 'Ocurrió un error al guardar la OT, intente nuevamente', type: 'error', open: true })
            });
    }

    const handleCloseSanckbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarInfo({ text: '', type: 'info', open: false });
    };

    const handleCloseModal = () => {
        setOpenGarantiaModal(false);
    };

    const formatDataToSaveGarantia = (row, index) => {
        const dataRowToSave = {
            idOt: row.id,
            cliente: row.cliente,
            comments: row.comments,
            contrato: row.contrato,
            cuadrilla: row.cuadrilla,
            date: row.date,
            nroFormulario: row.nroFormulario,
            nroOt: row.nroOt,
            services: row.services,
            indexRow: index,
            tipoCliente: row.tipoCliente,
            tipoDia: row.tipoDia,
        };
        return dataRowToSave;
    }

    const changeCheckGarantia = (index, row) => {
        const dataRowToSave = formatDataToSaveGarantia(row, index);
        if (checkRow?.includes(index)) {
            setCheckRow(checkRow.filter(item => item !== index));
            const indexDelete = garantias.findIndex((obj) => obj.indexRow === index)
            garantias.splice(indexDelete, 1);
            setGarantias(prevState => ([...prevState]));
        } else {
            setCheckRow([...checkRow, index]);
            const newArray = [...garantias, dataRowToSave]
            setGarantias(newArray)
        }
    }

    const onChangeSelectGarantia = (e, row, index) => {
        e.preventDefault();
        const dataRowToSave = formatDataToSaveGarantia(row, index);
        const indexSave = garantias.findIndex((obj) => obj.indexRow === index)
        garantias[indexSave].otRelacionada = dataRowToSave;
        setGarantias(prevState => ([...prevState]))
    }

    const saveGarantias = async () => {
        if (garantias?.length > 0) {

            try {
                // Paso 1: Obtener el último ID
                const q = query(collection(firestore, "garantias"), orderBy("id", "desc"), limit(1));
                const querySnapshot = await getDocs(q);

                let lastId = 0;

                // Si existe al menos un documento, obtener el último ID
                if (!querySnapshot.empty) {
                    lastId = querySnapshot.docs[0].data().id;
                }

                // Paso 2: Generar el nuevo ID
                const newId = lastId + 1;

                // Paso 3: Crear el nuevo objeto de garantía
                // Función para limpiar datos problemáticos
                const cleanData = (obj) => {
                    if (!obj) return obj;
                    
                    const cleaned = {};
                    for (const [key, value] of Object.entries(obj)) {
                        if (value === null || value === undefined) {
                            cleaned[key] = null;
                        } else if (Array.isArray(value)) {
                            cleaned[key] = value.length > 0 ? value : null;
                        } else if (typeof value === 'object') {
                            cleaned[key] = cleanData(value); // Recursivo para objetos anidados
                        } else {
                            cleaned[key] = value;
                        }
                    }
                    return cleaned;
                };
                
                // Convertir el array en un objeto con índices como claves
                const garantiasObject = {};
                garantias.forEach((garantia, index) => {
                    garantiasObject[index] = cleanData(garantia);
                });
                
                const newGarantia = {
                    contrato: garantias[0]?.contrato,
                    id: newId,
                    date: garantias[0]?.date,
                    ...garantiasObject, // Ahora spread del objeto con índices
                };
                console.log("newGarantia", newGarantia, garantiasObject);

                // Paso 4: Guardar el nuevo registro en Firestore con el nuevo ID
                console.log("Intentando guardar con ID:", newId);
                console.log("Datos a guardar:", JSON.stringify(newGarantia, null, 2));
                
                await setDoc(doc(firestore, "garantias", newId.toString()), newGarantia);

                console.log("Garantía guardada correctamente");
                setActualStep("finishGarantia");
                setOpenGarantiaModal(false);

            } catch (error) {
                console.error("Error detallado al guardar la garantía:", error);
                console.error("Error code:", error.code);
                console.error("Error message:", error.message);
                // console.error("Datos que causaron el error:", JSON.stringify(newGarantia, null, 2));
                setSnackbarInfo({ text: `Error al guardar las garantías: ${error.message}`, type: "error", open: true });
            }
        }
    };

    // const onSaveGarantia = (lastId) => {
    //     const newArray = garantias
    //     const newId = lastId + 1;
    //     newArray.contrato = garantias[0]?.contrato;
    //     newArray.id = newId;
    //     newArray.date = garantias[0]?.date;
    //     set(ref(database, 'garantias/' + newId), newArray)
    //         .then(() => {
    //             console.log('ok garantias')
    //             setActualStep('finishGarantia')
    //             setOpenGarantiaModal(false);
    //         })
    //         .catch(() => setSnackbarInfo({ text: 'Ocurrió un error al guardar las garantias', type: 'error', open: true }))
    // }

    // const saveGarantias = () => {
    //     if (garantias?.length > 0) {
    //         let lastiIdGarantia = -1
    //         const topUserPostsRef = query(ref(database, 'garantias'), orderByChild('id'), limitToLast(1));
    //         onValue(topUserPostsRef, (snapshot) => {
    //             const key = snapshot.val() ? Object.keys(snapshot.val()) : -1;
    //             lastiIdGarantia = parseInt(key, 10);
    //             onSaveGarantia(lastiIdGarantia)
    //         }, {
    //             onlyOnce: true
    //         });
    //     }
    // }

    return (
        <>
            {actualStep === 'order' &&
                <AddOrdenes nextStep={goToService} />
            }
            {actualStep === 'service' &&
                <AddServices nextStep={goToMaterials} goToOrder={goToOrder} data={dataToSave} servicesData={services} />
            }
            {actualStep === 'material' &&
                <AddMaterials nextStep={goToService} data={dataToSave} onSave={onSave} />
            }
            {actualStep === 'finish' &&
                <div>
                    <Typography variant="h4">Guardado correctamente!</Typography>
                    <Button variant="contained" color="primary" href="/ordenes">Nueva OT</Button>
                    <Button href="/list-ordenes">
                        Ir a listado
                    </Button>
                </div>
            }
            {actualStep === 'finishGarantia' &&
                <div>
                    <Typography variant="h4">Garantia guardada correctamente!</Typography>
                    <Button variant="contained" color="primary" href="/ordenes">Nueva OT</Button>
                    <Button href="/list-ordenes">
                        Ir a listado
                    </Button>
                </div>
            }
            <Snackbar open={snackbarInfo.open} autoHideDuration={2000} onClose={handleCloseSanckbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert onClose={handleCloseSanckbar} severity={snackbarInfo.type} sx={{ width: '100%' }}>
                    {snackbarInfo.text}
                </Alert>
            </Snackbar>
            {openGarantiaModal &&
                <Dialog
                    open={openGarantiaModal}
                    onClose={(event, reason) => {
                        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                            handleCloseModal();
                        }
                    }}
                    disableEscapeKeyDown
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="xl"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Asignación de garantías"}
                    </DialogTitle>
                    <DialogContent>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nro Formulario</TableCell>
                                        <TableCell>Nro OT</TableCell>
                                        <TableCell>Contrato</TableCell>
                                        <TableCell>Cliente</TableCell>
                                        <TableCell>Fecha</TableCell>
                                        <TableCell>Cuadrilla</TableCell>
                                        <TableCell>Comentarios</TableCell>
                                        <TableCell>Es garantía?</TableCell>
                                        <TableCell>Garantía de</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {otGarantiaData.map((row, index) => (
                                        <TableRow
                                            key={row.id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell>{row.nroFormulario}</TableCell>
                                            <TableCell>{row.nroOt}</TableCell>
                                            <TableCell>{row.contrato}</TableCell>
                                            <TableCell>{row.cliente}</TableCell>
                                            <TableCell>{moment(row.date).format("DD/MM/YYYY")}</TableCell>
                                            <TableCell>{row.cuadrilla}</TableCell>
                                            <TableCell>{row.comments}</TableCell>
                                            <TableCell>
                                                <Checkbox
                                                    onChange={() => changeCheckGarantia(index, row)}
                                                    checked={checkRow?.includes(index)}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ minWidth: '160px' }}>
                                                <FormControl sx={{ width: '100%', margin: '10px 0' }}>
                                                    <Autocomplete
                                                        options={otGarantiaData}
                                                        id="disable-clearable"
                                                        disableClearable
                                                        onChange={(e, ot) => onChangeSelectGarantia(e, ot, index)}
                                                        getOptionLabel={(option) => option.nroOt}
                                                        fullWidth
                                                        disabled={!checkRow?.includes(index)}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label="Nro OT relacionada" placeholder="Nro OT relacionada" />
                                                        )}
                                                    />
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseModal}>Cerrar</Button>
                        <Button onClick={saveGarantias} autoFocus>
                            Guardar
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )

}

export default OTWrapper;
